module.exports = {
	"elementName": "ObjectSchema",
	"name": "ShapeBasic",
	"containers": [
		{
			"name": "container",
			"elementName": "Container",
			"style": {
				"top": 0,
				"left": 0,
				"width": 402,
				"height": 674,
				"position": "relative"
			},
			"props": {
				"startOnNewPage": false,
				"unbreakable": false
			},
			"boxes": [
				{
					"name": "Square",
					"elementName": "Shapes.Rectangle",
					"style": {
						"top": 0,
						"left": 3,
						"width": 120,
						"height": 120,
						"transform": {}
					},
					"props": {
						"width": 100,
						"height": 100,
						"strokeWidth": 2
					}
				},
				{
					"name": "Circle",
					"elementName": "Shapes.Circle",
					"style": {
						"top": 0,
						"left": 250,
						"width": 120,
						"height": 120,
						"transform": {}
					},
					"props": {
						"r": 50,
						"strokeWidth": 3
					}
				},
				{
					"name": "Ellipse",
					"elementName": "Shapes.Ellipse",
					"style": {
						"top": 379,
						"left": 6,
						"width": 120,
						"height": 240,
						"transform": {}
					},
					"props": {
						"rx": 50,
						"strokeWidth": 3
					}
				},
				{
					"name": "Line",
					"elementName": "Shapes.Line",
					"style": {
						"top": 125,
						"left": 0,
						"width": 120,
						"height": 120,
						"transform": {}
					},
					"props": {
						"x1": 5,
						"y1": 5,
						"x2": 100,
						"y2": 100,
						"strokeWidth": 10
					}
				},
				{
					"name": "Triangle",
					"elementName": "Shapes.Triangle",
					"style": {
						"top": 121,
						"left": 250,
						"width": 120,
						"height": 120,
						"transform": {}
					},
					"props": {
						"width": 100,
						"height": 100,
						"strokeWidth": 4
					}
				},
				{
					"name": "Rectangle",
					"elementName": "Shapes.Rectangle",
					"style": {
						"top": 0,
						"left": 126,
						"width": 120,
						"height": 250,
						"transform": {}
					},
					"props": {
						"width": 100,
						"height": 220,
						"strokeWidth": 2
					}
				},
				{
					"name": "LeftTriangle",
					"elementName": "Shapes.Triangle",
					"style": {
						"top": 252,
						"left": 248,
						"width": 120,
						"height": 120,
						"transform": {
							"tx": 0,
							"ty": 0,
							"sx": 1,
							"sy": 1,
							"rz": -1.5700520947318557,
							"ox": 0.5,
							"oy": 0.5
						}
					},
					"props": {
						"width": 100,
						"height": 100,
						"fill": "#ffac00",
						"stroke": "#2cd929",
						"strokeWidth": 4
					}
				},
				{
					"name": "BottomTriangle",
					"elementName": "Shapes.Triangle",
					"style": {
						"top": 249,
						"left": 0,
						"width": 120,
						"height": 120,
						"transform": {
							"tx": 0,
							"ty": 0,
							"sx": 1,
							"sy": 1,
							"rz": 3.1537161345388434,
							"ox": 0.5,
							"oy": 0.5
						}
					},
					"props": {
						"width": 100,
						"height": 100,
						"fill": "#ffac00",
						"stroke": "#2cd929",
						"strokeWidth": 4
					}
				},
				{
					"name": "RightTriangle",
					"elementName": "Shapes.Triangle",
					"style": {
						"top": 252,
						"left": 125,
						"width": 120,
						"height": 120,
						"transform": {
							"tx": 0,
							"ty": 0,
							"sx": 1,
							"sy": 1,
							"rz": 1.5846863320100764,
							"ox": 0.5,
							"oy": 0.5
						}
					},
					"props": {
						"width": 100,
						"height": 100,
						"fill": "#ffac00",
						"stroke": "#2cd929",
						"strokeWidth": 4
					}
				},
				{
					"name": "OrangeEllipse",
					"elementName": "Shapes.Ellipse",
					"style": {
						"top": 506,
						"left": 134,
						"width": 225,
						"height": 121,
						"transform": {}
					},
					"props": {
						"rx": 100,
						"ry": 50,
						"fill": "#f28124",
						"strokeWidth": 10
					}
				},
				{
					"name": "PinkEllipse",
					"elementName": "Shapes.Ellipse",
					"style": {
						"top": 384,
						"left": 134,
						"width": 249,
						"height": 122,
						"transform": {}
					},
					"props": {
						"rx": 100,
						"ry": 40,
						"fill": "#de1454",
						"stroke": "#1039e0",
						"strokeWidth": 20
					}
				}
			],
			"containers": []
		}
	],
	"data": {},
	"props": {
		"context": {}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/templates/ShapeBasic.json
 ** module id = 967
 ** module chunks = 0
 **/